export default "__VITE_ASSET__BNpltFWp__"